import React from 'react';
import { createPortal } from 'react-dom';

export default function LeaveSiteWarningModal({ onConfirm, onCancel }) {
    return createPortal(
        <div className="clinicsslots-modal-overlay leave-site-modal-overlay">
            <div className="clinicsslots-modal">
                <h3>You are leaving the IPRS Self Referral page</h3>
                <p className="leave-site-modal-message">Please note that you will need to return to this page to complete your referral through to an IPRS Health Physiotherapy Clinic.</p>
                <div className="modal-actions">
                    <button type="button" className="close-btn" onClick={onCancel}>Cancel</button>
                    <button type="button" className="confirm-btn" onClick={onConfirm}>Continue</button>
                </div>
            </div>
        </div>,
        document.body
    );
}
